import React, { useState, useEffect, useRef } from 'react';

import { motion } from "framer-motion";

import NaverLogin from 'react-naver-login';
import KakaoLogin from "react-kakao-login";

import { toast } from 'react-toastify';

import { useLang, usePopup, useUser } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import { emailMasking, regPhone, regEmail, regPassword, errorMessage } from "../utils/utils";
import * as APIS from "../utils/service";

import Image from './Image';
import Input from './Input';
import Button from './Button';
import ContainerLoader from './ContainerLoader';
import SignUp from './SignUp';

import images from '../libs/images';
import consts from '../libs/consts';

export default function SignFindPw({ setPage }) {

    const ref = useRef();
    const emailref = useRef();
    const hpref = useRef();
    const pwref = useRef();
    const repwref = useRef();

    const { signPop, closeSignPop } = usePopup();
    const { user, token, login } = useUser();
    const { country, getLang } = useLang();
    
    const [ email, setemail ] = useState('');
    const [ hp, sethp ] = useState('');
    const [ num, setnum ] = useState('');
    const [ pwToken, setpwToken ] = useState('');
    const [ pw, setpw ] = useState('');
    const [ repw, setrepw ] = useState('');

    const [ timer, setTimer ] = useState(false);
    const [ timerView, setTimerView ] = useState(false);

    const [ error, setError ] = useState({});
    const [ step, setstep ] = useState(1);
    const [ load, setLoad ] = useState(false);

    useEffect(() => {

        emailref?.current?.focus();

    }, [])

    const handleKeyDown = (e) => {
        if (e?.key === 'Enter') {
            if(step === 1) submitFunc()
            else if(step === 2) checkFunc()
            else if(step === 3) changeFunc()
        }
    };

    const timeOut = () => {

        console.log("타임 아웃입니다");
        setError({...error, num: <LangText id={'error_invalid_auth_time'}/>})
        setTimer(false);
        setstep(1);
    }

    const submitFunc = () => {

        if(!regEmail.test(email)) {
            setError({...error, findEmail: <LangText id={'error_reg_email'}/>})
            emailref?.current?.focus();
            return;
        }

        if(!regPhone.test(hp)) {
            setError({...error, findHp: <LangText id={'error_reg_hp'}/>})
            hpref?.current?.focus();
            return;
        }

        if(error?.findEmail || error?.findHp) return;
       
        let sender = {
            type: 3,
            email: email,
            hp: hp
        }

        APIS.post('/login/auth', sender).then(( { data } ) => {
            console.log('data', data);

            /** 가입되어있고, 인증번호 발송 했으면 */
            setTimer(true);
            setTimerView(true);
            setstep(2);

            setTimeout(() => {
                ref?.current?.focus();
            }, 100)
            /******************************/
        }).catch(({ response }) => {
            console.log(response);

            if(response?.data?.code === 1027) setError({...error, findEmail: <LangText id={response?.data?.msgkey}/>})
            else if(response?.data?.code === 1028) setError({...error, findHp: <LangText id={response?.data?.msgkey}/>})
            else errorMessage(response?.data);
        });
      
    }

    const checkFunc = () => {

        if(num?.length < 6) {
            setError({...error, findNum: <LangText id={'error_invalid_null_auth'}/>})
            return;
        }

        let sender = {
            type: 3,
            hp: hp,
            authNumber: num
        }
        APIS.post('/login/authCheck', sender).then(( { data } ) => {
            console.log('data', data);

            // 인증번호 일치시
            setpwToken(data);
            setstep(3);
            setTimer(false);

            setTimeout(() => {
                pwref?.current?.focus();
            }, 100)

        }).catch(({ response }) => {
            // errorMessage(response?.data);
            setError({...error, findNum: <LangText id={response?.data?.msgkey}/>})
            return;
        });
    }

    const changeFunc = () => {

        if(!regPassword.test(pw)) {
            setError({...error, findPw: <LangText id={'error_reg_pass'}/>})
            pwref?.current?.focus();
            return;
        }

        if(pw !== repw) {
            setError({...error, findRePw: <LangText id={'error_match_pass'}/>})
            repwref?.current?.focus();
            return;
        }

        let sender = {
            token: pwToken,
            pass1: pw,
            pass2: repw
        }
        APIS.post('/login/changePass', sender).then(( { data } ) => {
            console.log('data', data);

            toast.success(<LangText id={'success_change_pass'} />);
            setPage('');

        }).catch(({ response }) => {
            // errorMessage(response?.data);
            errorMessage(response?.data);
            // setError({...error, findNum: <LangText id={response?.data?.msgkey}/>})
            return;
        });
    }

    return (
        
        
        <div
            className="login_root"
        >
            
            <ContainerLoader load={load}/>

            <div className='img' />

            <p className='title'>
                <LangText id={'text_find_pass'}/>
            </p>
            <p className='sub_title'>
                <LangText id={'info_input_email_hp'}/>
            </p>

            <div className='find_form'>
                <Input 
                    refs={emailref}
                    type="text" 
                    name="findEmail" 
                    value={email} 
                    setValue={setemail} 
                    onKeyDown={handleKeyDown} 
                    label={<LangText id={'text_email'}/>} 
                    error={error} 
                    setError={setError}
                    disabled={timer || step === 3}
                />

                <Input 
                    refs={hpref}
                    type="tel" 
                    name="findHp" 
                    value={hp} 
                    setValue={sethp} 
                    onKeyDown={handleKeyDown} 
                    label={<LangText id={'text_hp'}/>} 
                    error={error} 
                    setError={setError}
                    disabled={timer || step === 3}
                />
                
                
                {(step < 3 && timerView) && (
                    <Input 
                        refs={ref}
                        type="tel" 
                        name="findNum" 
                        value={num} 
                        setValue={setnum} 
                        onKeyDown={handleKeyDown} 
                        label={<LangText id={'text_authnum'}/>} 
                        error={error} 
                        setError={setError} 
                        maxlength={6}
                        timer={timer}
                        timerState={timeOut}
                        readOnly={!timer}
                    />
                )}

                {step === 3 && (
                    <div className='new_pw_box'>
                        <Input 
                            refs={pwref}
                            type="password"
                            name="findPw" 
                            placeholder={getLang({key: 'placeholder_pass'})}
                            value={pw} 
                            setValue={setpw} 
                            onKeyDown={handleKeyDown} 
                            label={<LangText id={'text_new_pass'}/>} 
                            error={error} 
                            setError={setError}
                        />
                        <Input 
                            refs={repwref}
                            type="password"
                            name="findRePw" 
                            placeholder={getLang({key: 'placeholder_pass_re'})}
                            value={repw} 
                            setValue={setrepw} 
                            onKeyDown={handleKeyDown} 
                            error={error} 
                            setError={setError}
                        />
                    </div>
                )}

            </div>

            <div className='find_btns'>
                {step === 1 ? (
                    <Button title={<LangText id={'btn_get_auth'}/>} onClick={submitFunc}/>
                ) : step === 2 ? (
                    <Button title={<LangText id={'btn_check_auth'}/>} onClick={checkFunc}/>
                ) : step === 3 ? (
                    <Button title={<LangText id={'btn_change_pass'}/>} onClick={changeFunc}/>
                ) : (
                    <></>
                )}
            </div>

            <p className='help_msg'>
                <LangText id={'info_social_login_long'}/>
            </p>

        </div>

    )    
}